import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type {
    AggregatorConfigRequestData,
    FoodmeowStoreResponse,
    Location,
    LocationDetail,
    LocationsListItem,
    OAuthTokensInput,
    ServiceDetail,
    UberStoreResponse,
} from "../../../graphql/types"
import type { AggregatorCreateFormFields } from "./aggregatorForm/Create"
import type { AggregatorIntegrateFormData } from "./aggregatorForm/Integrate"
import type { AggregatorType } from "./aggregatorForm/aggregatorTypeEnum"

export const LOCATION_AGENDA_MOUNTED = "location/agenda/mounted"
export const locationAgendaMounted = () => ({
    type: LOCATION_AGENDA_MOUNTED,
})

export const FETCH_LOCATIONS_SUCCESS = "fetchLocations/success"
export const fetchLocationsSuccess = (locations: Location[]) => ({
    type: FETCH_LOCATIONS_SUCCESS,
    payload: {
        locations: locations,
    },
})

export const FETCH_LOCATIONS_FAILURE = "fetchLocations/failure"
export const fetchLocationsFailure = (error: any) => ({
    type: FETCH_LOCATIONS_FAILURE,
    payload: {
        error: error,
    },
})

export const FETCH_LOCATIONS_LIST_SUCCESS = "fetchLocationsList/success"
export const fetchLocationsListSuccess = (data: LocationsListItem[]) => ({
    type: FETCH_LOCATIONS_LIST_SUCCESS,
    payload: {
        data: data,
    },
})

export const FETCH_LOCATIONS_LIST_ERROR = "fetchLocationsList/error"
export const fetchLocationsListError = (error: any) => ({
    type: FETCH_LOCATIONS_LIST_ERROR,
    payload: {
        error: error,
    },
})

export const LOCATION_DETAIL_AGENDA_MOUNTED = "location/detail/mounted"
export const locationDetailAgendaMounted = () => ({
    type: LOCATION_DETAIL_AGENDA_MOUNTED,
})

export const FETCH_LOCATION_DETAIL_SUCCESS = "fetchLocationsDetail/success"
export const fetchLocationDetailSuccess = (data: Maybe<LocationDetail>) => ({
    type: FETCH_LOCATION_DETAIL_SUCCESS,
    payload: {
        data: data,
    },
})

export const FETCH_LOCATION_DETAIL_ERROR = "fetchLocationsDetail/error"
export const fetchLocationDetailError = (error: any) => ({
    type: FETCH_LOCATION_DETAIL_ERROR,
    payload: {
        error: error,
    },
})

export const AGGREGATOR_SERVICE_DETAIL_FORM_AGENDA_MOUNTED = "aggregator-service/mounted"
export const aggregatorServiceDetailFormMounted = () => ({
    type: AGGREGATOR_SERVICE_DETAIL_FORM_AGENDA_MOUNTED,
})

export const FETCH_SERVICE_DETAIL_SUCCESS = "fetchServiceDetail/success"
export const fetchServiceDetailSuccess = (data: Maybe<ServiceDetail>) => ({
    type: FETCH_SERVICE_DETAIL_SUCCESS,
    payload: {
        data: data,
    },
})

export const FETCH_SERVICE_DETAIL_ERROR = "fetchServiceDetail/error"
export const fetchServiceDetailError = (error: any) => ({
    type: FETCH_SERVICE_DETAIL_ERROR,
    payload: {
        error: error,
    },
})

export const LOCATION_FORM_SUBMITTED = "location/form/submitted"
export const locationFormSubmitted = (oldValue: Maybe<LocationDetail>, newValue: LocationDetail) => ({
    type: LOCATION_FORM_SUBMITTED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
    },
})

export const DELETE_TERMINAL_FAILURE = "deleteTerminal/failure"
export const deleteTerminalFailure = (error: any) => ({
    type: DELETE_TERMINAL_FAILURE,
    payload: {
        error: error,
    },
})

export const DELETE_LOCATION_CLICKED = "location/delete/clicked"
export const deleteLocationClicked = (id: string) => ({
    type: DELETE_LOCATION_CLICKED,
    payload: {
        locationId: id,
    },
})

export const DELETE_TERMINAL_CLICKED = "terminal/delete/clicked"
export const deleteTerminalClicked = (terminalId: string, locationId: string, skipRequest?: boolean) => ({
    type: DELETE_TERMINAL_CLICKED,
    payload: {
        terminalId: terminalId,
        locationId: locationId,
        skipRequest: skipRequest,
    },
})

export const LOCATION_FORM_UNMOUNTED = "location/form/unmounted"
export const locationFormUnmounted = () => ({
    type: LOCATION_FORM_UNMOUNTED,
})

export const CLOSE_LOCATION_FORM_CLICKED = "location/close/clicked"
export const closeLocationFormClicked = () => ({
    type: CLOSE_LOCATION_FORM_CLICKED,
})

export const CLOSE_TERMINAL_FORM_CLICKED = "terminal/close/clicked"
export const closeTerminalFormClicked = () => ({
    type: CLOSE_TERMINAL_FORM_CLICKED,
})

export const CLOSE_AGGREGATOR_FORM_CLICKED = "aggregator/close/clicked"
export const closeAggregatorFormClicked = () => ({
    type: CLOSE_AGGREGATOR_FORM_CLICKED,
})

export const DELETE_AGGREGATOR_CLICKED = "aggregator/delete/clicked"
export const deleteAggregatorClicked = (aggregatorId: string, type: AggregatorType, locationId: string) => ({
    type: DELETE_AGGREGATOR_CLICKED,
    payload: {
        aggregatorId: aggregatorId,
        type: type,
        locationId: locationId,
    },
})

export const SAVE_LOCATION_SUCCESS = "location/save/success"
export const saveLocationSuccess = () => ({
    type: SAVE_LOCATION_SUCCESS,
})

export const SAVE_LOCATION_FAILURE = "saveLocation/failure"
export const saveLocationFailure = (error: any) => ({
    type: SAVE_LOCATION_FAILURE,
    payload: {
        error: error,
    },
})

export const SAVE_TERMINAL_SUCCESS = "terminal/save/success"
export const saveTerminalSuccess = () => ({
    type: SAVE_TERMINAL_SUCCESS,
})

export const SAVE_TERMINAL_FAILURE = "saveTerminal/failure"
export const saveTerminalFailure = (error: any) => ({
    type: SAVE_TERMINAL_FAILURE,
    payload: {
        error: error,
    },
})

export const SERVICE_INTEGRATE_3RD_PARTY_REQUESTED = "service/integrate/requested"
export const serviceIntegrate3rdPartyRequested = (serviceId: string, locationId: string, type: "uber" | "email") => ({
    type: SERVICE_INTEGRATE_3RD_PARTY_REQUESTED,
    payload: {
        serviceId: serviceId,
        locationId: locationId,
        type: type,
    },
})

export const AGGREGATOR_CREATE_FORM_SUBMITTED = "service/aggregator/created"
export const aggregatorCreateFormSubmitted = (formData: AggregatorCreateFormFields) => ({
    type: AGGREGATOR_CREATE_FORM_SUBMITTED,
    payload: {
        formData: formData,
    },
})

export const AGGREGATOR_INTEGRATE_FORM_SUBMITTED = "service/aggregator/updatedToIntegrate"
export const aggregatorIntegrateFormSubmitted = (data: AggregatorIntegrateFormData) => ({
    type: AGGREGATOR_INTEGRATE_FORM_SUBMITTED,
    payload: data,
})

export const AGGREGATOR_INTEGRATION_REQUESTED = "service/aggregator/integrate/requested"
export const aggregatorIntegrationRequested = (
    locationId: string,
    terminalId: string,
    aggregatorType: AggregatorType,
    terminalName: string
) => ({
    type: AGGREGATOR_INTEGRATION_REQUESTED,
    payload: {
        locationId: locationId,
        terminalId: terminalId,
        aggregatorType: aggregatorType,
        terminalName: terminalName,
    },
})

export const AGGREGATOR_UBER_STORES_REQUESTED = "service/aggregator/uber/stores/requested"
export const aggregatorUberStoresRequested = (code?: string, serviceId?: string) => ({
    type: AGGREGATOR_UBER_STORES_REQUESTED,
    payload: {
        code: code,
        serviceId: serviceId,
    },
})

export const AGGREGATOR_UBER_STORES_SUCCESS = "service/aggregator/uber/stores/success"
export const aggregatorUberStoresSuccess = (response: UberStoreResponse) => ({
    type: AGGREGATOR_UBER_STORES_SUCCESS,
    payload: response,
})

export const AGGREGATOR_UBER_STORES_ERROR = "service/aggregator/uber/stores/error"
export const aggregatorUberStoresError = (error: any) => ({
    type: AGGREGATOR_UBER_STORES_ERROR,
    payload: error,
})

export const AGGREGATOR_UBER_STORE_SELECTED = "service/aggregator/uber/store/selected"
export const aggregatorUberStoreSelected = (
    auth: Maybe<OAuthTokensInput>,
    storeId: string,
    locationId: string,
    terminalId: string
) => ({
    type: AGGREGATOR_UBER_STORE_SELECTED,
    payload: {
        auth: auth,
        storeId: storeId,
        locationId: locationId,
        terminalId: terminalId,
    },
})

export const AGGREGATOR_FOODMEOW_STORES_REQUESTED = "service/aggregator/foodmeow/stores/requested"
export const aggregatorFoodmeowStoresRequested = (code: string) => ({
    type: AGGREGATOR_FOODMEOW_STORES_REQUESTED,
    payload: {
        code: code,
    },
})

export const AGGREGATOR_FOODMEOW_STORES_SUCCESS = "service/aggregator/foodmeow/stores/success"
export const aggregatorFoodmeowStoresSuccess = (response: FoodmeowStoreResponse) => ({
    type: AGGREGATOR_FOODMEOW_STORES_SUCCESS,
    payload: response,
})

export const AGGREGATOR_FOODMEOW_STORES_ERROR = "service/aggregator/foodmeow/stores/error"
export const aggregatorFoodmeowStoresError = (error: any) => ({
    type: AGGREGATOR_FOODMEOW_STORES_ERROR,
    payload: error,
})

export const AGGREGATOR_FOODMEOW_STORE_SELECTED = "service/aggregator/foodmeow/store/selected"
export const aggregatorFoodmeowStoreSelected = (
    token: string,
    storeId: string,
    locationId: string,
    terminalId: string
) => ({
    type: AGGREGATOR_FOODMEOW_STORE_SELECTED,
    payload: {
        token: token,
        storeId: storeId,
        locationId: locationId,
        terminalId: terminalId,
    },
})

export const INTEGRATE_AGGREGATOR_SUCCESS = "service/aggregator/integrate/success"
export const integrateAggregatorSuccess = (locationId: string, terminalId: string) => ({
    type: INTEGRATE_AGGREGATOR_SUCCESS,
    payload: {
        locationId: locationId,
        terminalId: terminalId,
    },
})

export const AGGREGATOR_EDIT_FORM_SUBMITTED = "service/aggregator/edited"
export const aggregatorEditFormSubmitted = (item: {
    id: string
    locationId: string
    name: string
    aggregatorConfig: Maybe<AggregatorConfigRequestData>
    priceMultiplier?: Maybe<number>
    shouldRoundUpPrices?: boolean
}) => ({
    type: AGGREGATOR_EDIT_FORM_SUBMITTED,
    payload: item,
})
